import sidebar from '@/config/sidebars/gsc_ga4'
import createVueApp from '@/common/create_app'

Styxie.Initializers.GscGa4GscProperties = {
  index: async(props) => {
    const { default: GscPropertiesIndex } = await import('@/vue_widgets/gsc_ga4/gsc_properties/index.vue')
    createVueApp(GscPropertiesIndex, { props, sidebar })
  }
}
